import {ReactComponent as Notifications} from 'assets/icons/notifications.svg'
import {ReactComponent as Logout} from 'assets/icons/logout.svg'
import {ReactComponent as Settings} from 'assets/icons/settings.svg'
import {ReactComponent as Profile} from 'assets/icons/profile.svg'
import {ReactComponent as Statistics} from 'assets/icons/statistics.svg'
import {ReactComponent as Clients} from 'assets/icons/clients.svg'
import {ReactComponent as Home} from 'assets/icons/home.svg'
import {ReactComponent as Support} from 'assets/icons/support.svg'
import {ReactComponent as Pdf} from 'assets/icons/pdf.svg'
import {ReactComponent as Excel} from 'assets/icons/excel.svg'
import {ReactComponent as Expand} from 'assets/icons/expand.svg'
import {ReactComponent as Subscriptions} from 'assets/icons/subscriptions.svg'
import {ReactComponent as PaymentTypes} from 'assets/icons/paymentTypes.svg'
import {ReactComponent as CommonQuestions} from 'assets/icons/commonQuestions.svg'
import {ReactComponent as Guides} from 'assets/icons/guides.svg'

const Icons = {
    Notifications,
    Logout,
    Settings,
    Profile,
    Statistics,
    Clients,
    Home,
    Support,
    Pdf,
    Excel,
    Expand,
    Subscriptions,
    PaymentTypes,
    CommonQuestions,
    Guides,
}
export default Icons
